// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_lp-0";